import React, { useState } from 'react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import LeftSidebar from '@/js/components/sidebars/LeftSidebar';
import SidebarSheetWrapper from '@/js/components/sidebars/SidebarSheetWrapper';
import Breadcrumb from '@/js/components/Breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SearchResultsCard from '@/js/components/card/SearchResultsCard';
import ShortlistedManuCard from '@/js/components/card/ShortlistedManuCard';

const steps = [{ id: 1, label: 'Shortlisted Manufacturer' }];

const ManufacturerBookmarked = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [sectionId, setSectionId] = useState(1);
  const { projectId, projectName } = useParams();

  const searchReduxData = useSelector((state) => state?.searchReducer);
  const [selected, setSelected] = useState([]);
  const shortlisted = searchReduxData?.shortlisted;

  const toggleSelect = (item) => {
    setSelected((prev) =>
      prev.some((manu) => manu.manufacturer_id === item.manufacturer_id)
        ? prev.filter((manu) => manu.manufacturer_id !== item.manufacturer_id)
        : [...prev, item],
    );
  };

  return (
    <div className="font-roboto bg-backgroundGray min-h-[calc(100vh-70px)] relative">
      <div className="absolute left-20 top-3">
        <Breadcrumb
          steps={steps}
          className="bg text-sm w-full"
          currentStep={sectionId}
        />
      </div>
      <div className="grid grid-cols-customCP12 min-h-[calc(100vh-70px)]">
        <div className="lg:hidden col-span-12 p-4">
          <Drawer>
            <DrawerTrigger asChild>
              <Menu size={28} className="cursor-pointer mt-7 ml-5" />
            </DrawerTrigger>
            <DrawerContent>
              <div className="mx-auto w-full max-w-sm">
                <DrawerHeader>
                  <DrawerTitle>Menu</DrawerTitle>
                </DrawerHeader>
                <LeftSidebar role="buyer" />
                <DrawerClose asChild>
                  <Button variant="outline" className="w-full">
                    Close
                  </Button>
                </DrawerClose>
              </div>
            </DrawerContent>
          </Drawer>
        </div>

        {/* Desktop Sidebar */}
        <div className="hidden lg:block lg:col-span-1">
          <div className="side-menu h-full pt-5">
            <SidebarSheetWrapper role="buyer" />
          </div>
        </div>

        {/* Main Content */}
        <div className="col-span-11 mt-10 mb-4 mx-3 rounded-lg relative overflow-hidden">
          <div className="font-roboto grid grid-cols-12 gap-x-6 min-h-[calc(100vh-70px)] overflow-hidden">
            <div className="px-6 col-span-12 bg-white p-4 rounded shadow h-full max-h-screen overflow-y-auto">
              <div className="flex justify-between items-center mb-4">
                <h1 className="font-bold text-lg">Shortlisted Manufacturer</h1>

                <div className="flex items-center gap-4">
                  <button className="text-darkPurple font-medium border border-darkPurple rounded px-2 hover:text-darkerPurple hover:bg-veryLightPurple hover:bg-opacity-15 ease-in duration-200 py-1">
                    Compare
                  </button>
                  <button className="text-darkPurple font-medium border border-darkPurple rounded px-2 hover:text-darkerPurple hover:bg-veryLightPurple hover:bg-opacity-15 ease-in duration-200 py-1">
                    Share NDA
                  </button>
                  <button
                    className="text-darkPurple font-medium border border-darkPurple rounded px-2 hover:text-darkerPurple hover:bg-veryLightPurple hover:bg-opacity-15 ease-in duration-200 py-1"
                    onClick={() => {
                      navigate('/project/createRFQ');
                    }}
                  >
                    Send RFQ
                  </button>
                </div>
              </div>

              <div
                className="grid grid-cols-3 gap-16 overflow-y-auto relative"
                style={{
                  scrollbarWidth: 'none',
                  scrollbarColor: '#B2BBC6 #F2F4F7',
                }}
              >
                {shortlisted.length > 0 &&
                  shortlisted.map((result, index) => (
                    <ShortlistedManuCard
                      key={index}
                      item={result}
                      index={index}
                      selected={selected}
                      toggleSelect={toggleSelect}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManufacturerBookmarked;
